import Modal from 'react-modal';
import { useEffect, useState } from 'react';
import { addFocusToTheElement, changeDisable, checkIfArrayAlreadyWasListed, convertDateToBrazilianFormat, custom, customFullModal, customHalfModal, customShortModal, dateToday, getParameter, getPermission, hoursNow, parseToFloat, removeEmptyValuesOfObject, setMaskDecimal, setMaskGeneric, showMessageError, viewItemProduct, } from '../../../classes/functions';
import { IoIosArrowDown } from "react-icons/io";
import './requests.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaArchive, FaArrowAltCircleLeft, FaCog, FaPlus, FaPrint, FaSearch, FaTrash } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import ModalFinalizeSeparation from '../../../components/Modal/ModalsRequests/ModalFinalizeSeparation';
import ModalStartSeparation from '../../../components/Modal/ModalsRequests/ModalStartSeparation';
import ModalReverseSeparation from '../../../components/Modal/ModalsRequests/ModalReverseSeparation';
import ModalReverseAproveSeparation from '../../../components/Modal/ModalsRequests/ModalReverseAproveSeparation';
import ModalPauseSeparation from '../../../components/Modal/ModalsRequests/ModalPauseSeparation';
import ModalMakeReturn from '../../../components/Modal/ModalsRequests/ModalMakeReturn';
import ModalFeaturesOpen from '../../../components/Modal/ModalsRequests/ModalFeaturesOpen';
import ModalLogFeaturesOpen from '../../../components/Modal/ModalsRequests/ModalLogFeaturesOpen';
import ListLog from '../../../components/ListLog';
import { format } from 'date-fns';
import download from 'downloadjs';
import ModalDeliverSignature from '../../../components/Modal/ModalDeliverSignature/index.js';
import ModalLog from "./modals/ModalLog";
import ModalSeparation from "./modals/ModalSeparation";
import ModalViewLog from "./modals/ModalViewLog";
import ModalConfirmation from '../../../components/Modal/ModalConfirmation/index.js';
import { createRef } from 'react';
import { useRef } from 'react';
import axios from 'axios';
import baseURL from '../../../baseUrl.js';
import ModalChoice from '../../../components/Modal/ModalChoice/index.js';
import Select from "react-select";
import { defaultStylesSelectLib } from '../../../classes/consts.js';
import InputDate from '../../../components/Inputs/Date/index.js';
import { customStyleSelect as defaultStyleSelectLib } from "../../../classes/consts";

export default function ProductRequests() {
    const { option, id } = useParams();
    const history = useHistory();
    const [view, setView] = useState(false);
    const [carrying, setCarrying] = useState(true);
    const [carryingExcel, setCarryingExcel] = useState(false);
    const [modalMakeReturn, setModalMakeReturn] = useState(false);
    const [modalSeparationOpenWithoutTag, setSeparationOpenWithoutTag] = useState(false);
    const [modalFeaturesOpen, setModalFeaturesOpen] = useState(false);
    const [modalFieldsOpen, setModalFieldsOpen] = useState(false);
    const [modalEditInfo, setModalEditInfo] = useState(false);
    const [modalStartSeparation, setModalStartSeparation] = useState(false);
    const [modalPauseSeparation, setModalPauseSeparation] = useState(false);
    const [modalReverseSeparation, setModalReverseSeparation] = useState(false);
    const [modalFinishSeparation, setModalFinishSeparation] = useState(false);
    const [modalReverseAproveSeparation, setModalReverseAproveSeparation] = useState(false);
    const [modalDispatch, setModalDispatch] = useState(false);
    const [modalListPallets, setModalListPallets] = useState(false);
    const [modalAlertDispatch, setModalAlertDispatch] = useState({open: false, message: "", isEnd: false});
    const [modalLogFeaturesOpen, setModalLogFeaturesOpen] = useState(false);
    const [modalLog, setModalLog] = useState(false);
    const [showModalDeliverSignature, setShowModalDeliverSignature] = useState(false);
    const [showSeparationModal, setShowSeparationModal] = useState(false);
    const [listProducts, setListProducts] = useState([]);
    const [listFeatures, setListFeatures] = useState([]);
    const [listStatus, setListStatus] = useState([]);
    const [listSearchCliente, setListSearchCliente] = useState([]);
    const [listBatchs, setListBatchs] = useState([]);
    const [listPallets, setListPallets] = useState([]);
    const [listUnits, setListUnits] = useState([]);
    const [listLogSeparation, setListLogSeparation] = useState([]);
    const [conferenceFeatures, setConferenceFeatures] = useState([]);
    const [feature, setFeature] = useState([]);
    const [fields, setFields] = useState([]);
    const [searchListProducts, setSearchListProducts] = useState('');
    const [cliente, setCliente] = useState('');
    const [item_form_quantidade, setItemFormQuantidade] = useState('');
    const [lotInputValue, setLotInputValue] = useState('');
    const [qtdeProduct, setQtdeProduct] = useState(0);
    const [qtdeEngage, setQtdeEngage] = useState(0);
    const [qtdeProductFeature, setQtdeProductFeature] = useState(0);
    const [qtdeSharedFeature, setQtdeSharedFeature] = useState(0);
    const [qtdeEngageFeature, setQtdeEngageFeature] = useState(0);
    const [qtdeEngageRequest, setQtdeEngageRequest] = useState(0);
    const [solicitante, setSolicitante] = useState(0);
    const [defaultWarehouse, setDefaultWarehouse] = useState({value: "", label: ""});
    const [rows, setRows] = useState([]);
    const [rows_deleted, setRowsDeleted] = useState([]);
    const [nome_cliente, setNomeCliente] = useState(getParameter('CLIENTE_PADRAO') || '');
    const reverseToERPParamater = getParameter('ESTORNAR_PARA_ERP');
    const nameToReverseSeparation = getParameter('TEXTO_ESTORNAR_REQUISICAO');
    const defineLotIsAllowed = getParameter("DEFINE_LOTE_REQ");
    const defineWarehouseIsAllowed = getParameter("DEFINE_ARMAZEM_REQ");
    const currentUserIsRequester = (parseInt(localStorage.getItem("usuario")) === solicitante);
    const userHasAllPermissions = (!getPermission("OPERACOES - REQUISICOES - EDITA TERCEIROS"));

    const [controls_pallet, setControlsPallet] = useState('');
    const [controls_serie, setControlsSerie] = useState('');
    const [controls_mac, setControlsMac] = useState('');
    const [controls_lot, setControlsLot] = useState('');

    const [listOptionsMacSerie, setListOptionsMacSerie] = useState([]);
    const [listOptionsMacSerieFiltred, setListOptionsMacSerieFiltred] = useState([]);
    const [listMacSerieSeleted, setListMacSerieSeleted] = useState([]);
    const [modalConfirmPrintTags, setModalConfirmPrintTags] = useState(false);
    const [modalConfirmTags, setModalConfirmTags] = useState(false);
    const [addedItems, setAddedItems] = useState('N');
    const [idPreview, setIdPreview] = useState();
    const [entreposto, setEntreposto] = useState('');
    const [label_message_tag, setLabelMessageTag] = useState('');
    const [observacao, setObservacao] = useState('');
    const [status, setStatus] = useState('');
    const [origin, setOrigin] = useState('');
    const [data_solicitacao, setDataSolicitacao] = useState('');
    const [hora_solicitacao, setHoraSolicitacao] = useState('');
    const [itemId, setItemId] = useState('');
    const [palletToDispatch, setPalletToDispatch] = useState('');
    const [index_aux, setIndex] = useState('');
    const [listReturn, setListReturn] = useState([]);
    const [observation_return, setObservationReturn] = useState('');
    const [documentNumber, setDocumentNumber] = useState('');
    const [logFeature, setLogFeature] = useState([]);
    const [rows_log, setRowsLog] = useState([]);
    const [view_log, setViewLog] = useState({});
    const [modalViewLog, setModalViewLog] = useState(false);
    const [modalTagsReceipt, setModalTagsReceipt] = useState(false);
    const [signature, setSignature] = useState();
    const [receiver, setReceiver] = useState('');
    const [receiverID, setReceiverID] = useState(0);
    const [users, setUsers] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [separations, setSeparations] = useState([]);
    const [macSerieNumber, setMacSerieNumber] = useState('');
    const [separator, setSeparator] = useState("");
    const [separatorName, setSeparatorName] = useState("");
    const [warehouses, setWarehouses] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState({label: "", value: "", unidade_medida: ""});
    const [selectedUnit, setSelectedUnit] = useState({label: "", value: ""});
    const [selectedWarehouse, setSelectedWarehouse] = useState({label: "", value: ""});
    const [selectedLot, setSelectedLot] = useState({label: "", value: ""});
    const [selectedPallet, setSelectedPallet] = useState({label: "", value: ""});
    const [listTagsToPrint, setListTagsToPrint] = useState([]);
    const [listTagsReceipt, setListTagsReceipt] = useState([]);
    const [listTagsReceiptByProduct, setListTagsReceiptByProduct] = useState([]);
    const [cancelToken, setCancelToken] = useState(null);
    const [itens, setItens] = useState([]);
    const selectLib = useRef();
    const [generationTags, setGenerationTags] = useState({
        label_product: '',
        id_product: '',
        quantity: 0
    });
    const [infos, setInfos] = useState({
        signature: {
            extension: "",
            serverName: "",
            base64: ""
        },
    });
    const [inputsValues, setInputsValues] = useState({
        data_solicitacao: "",
        data_agendamento: "",
        hora_agendamento: ""
    });
    const checkIfButtonOfAddItemMustToBeDisplayed = !id || (id && !view && ['001'].indexOf(status) > -1 && (parseInt(localStorage.getItem("usuario")) === solicitante || getPermission("OPERACOES - REQUISICOES - EDITA TERCEIROS")));
    const customStylesFeatures = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            width: '500px',
            maxHeight: '80%',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };
    const customStyleSelect = {
        control: ((style) => ({
            ...style,
            height: "35px",
            border: "1px solid #dce4ec",
            borderRadius: "5px"
        })),
        valueContainer: ((style) => ({
            ...style,
                height: "35px",
        })),
        singleValue: ((style) => ({
            ...style,
            verticalAlign: "center",
        })),
        placeholder: ((style) => ({
            ...style,
            verticalAlign: "center"
        }))
    }
    const tableHeaders = [
        { name: "", validation: ['007'].indexOf(status) > -1, scope: 1 },
        { name: "Produto", validation: true, scope: 2 },
        { name: "Unidade Medida", validation: true, scope: 1 },
        { name: "Série/MAC", validation: getParameter('DEFINE_SERIE_MAC_REQ') == 'T', scope: 1 },
        { name: "Característica", validation: listFeatures.length > 0, scope: 1 },
        { name: "Quantidade Solicitada", validation: true, scope: 1 },
        { name: "Quantidade Separada", validation: true, scope: 1 },
        { name: "Quantidade Conferida", validation: true, scope: 1 },
        { name: "Quantidade Eliminada", validation: true, scope: 1 },
        { name: "Quantidade Solicitada Devolução", validation: ['007'].indexOf(status) > -1, scope: 1 },
        { name: "Quantidade Devolvida", validation: ['007'].indexOf(status) > -1, scope: 1 },
        { name: "Quantidade Disponível Devolução", validation: ['007'].indexOf(status) > -1, scope: 1 },
        { name: "Log", validation: id, scope: 1 },
        { name: "Separação", validation: !(['001', '002', '003', '004'].indexOf(status) > -1), scope: 1 },
        { name: "Opções", validation: ['001', '002', '008'].indexOf(status) > -1, scope: 1 }
    ];
    const [showModals, setShowModals] = useState({
        confirmDelete: false
    });
    const buttonToConfirmDispatch = createRef();

    const getSignature = () => {
        api
            .get(`/api/products_requests/${id}/entregar`)
            .then((response) => {
                setInfos((prevState) => ({
                    ...prevState,
                    signature: ({ ...prevState, base64: response.data.assinatura })
                }));
            })
            .catch((error) => {
                if (error.response.data.message) {
                    showMessageError(error.response.data);
                }
            });
    }

    function validForm() {
        if (rows.length < 1 || !cliente || (getParameter("DEFINE_USUARIO_REQ") === "T" && !separator)) {
            toast.error('Preencha todos os campos com * para realizar cadastro.');
            return false;
        }

        return true;
    }

    function closeModalInfo() {
        setModalEditInfo(false);
        setSeparationOpenWithoutTag(true);
    }

    function closeModal() {
        setModalReverseAproveSeparation(false);
        setSeparationOpenWithoutTag(false);
        setModalFinishSeparation(false);
        setModalPauseSeparation(false);
        setModalFeaturesOpen(false);
        setModalTagsReceipt(false);
        setModalFieldsOpen(false);
        setModalMakeReturn(false);
        setModalViewLog(false);
        setModalLog(false);
        setSelectedWarehouse({label: "", value: ""});
    }

    function save(e) {
        setCarrying(true);
        e.preventDefault();

        if (!validForm()) {
            setCarrying(false);
            return false;
        }

        const data = {
            row: {
                id_cliente: cliente,
                observacao: observacao,
                status: status,
                data: inputsValues.data_solicitacao,
                hora: hora_solicitacao,
            },
            rows: rows,
            rows_deleted: rows_deleted,
        };

        if(defaultWarehouse?.value){
            data.row.armazem = defaultWarehouse?.value;
        }

        if(inputsValues.data_agendamento !== "" && inputsValues.hora_agendamento){
            data.row.agendamento = `${inputsValues.hora_agendamento} ${convertDateToBrazilianFormat(inputsValues.data_agendamento)}`
        }

        if (getParameter("DEFINE_USUARIO_REQ") === "T") {
            data.row.usuario_responsavel = separator;
        }

        if (idPreview) {
            data.row.id = idPreview;
            api.put("/api/product_requests/put", data)
                .then(() => {
                    toast.success('Registro atualizado com sucesso.');
                    history.push('/product_requests');
                }
                ).catch((error) => {
                    showMessageError(error.response.data);
                    setCarrying(false);
                });
        } else {
            api.post("/api/product_requests/post", data)
                .then(() => {
                    toast.success('Registro inserido com sucesso.');
                    history.push('/product_requests');
                }
                ).catch((error) => {
                    showMessageError(error.response.data);
                    setCarrying(false);
                });
        }
    }

    function getOne(id_search, option) {
        setCarrying(true);
        
        api.get("/api/product_requests/getList?id=" + id_search)
            .then((response) => {
                const date = response?.data?.row?.agendamento?.split(" ")[0] || "";
                const time = response?.data?.row?.agendamento?.split(" ")[1] || "";
                setNomeCliente(response.data.row.cliente.razao_social);
                setCliente(response.data.row.cliente.id);
                setObservacao(response.data.row.observacao);
                setEntreposto(response.data.row.entreposto);
                setOrigin(response.data.row.origin);
                setStatus(response.data.row.status);
                setInputsValues((prevState) => ({...prevState, data_solicitacao: response.data.row.data}));
                setHoraSolicitacao(response.data.row.hora);
                setDocumentNumber(response.data.row.numero_documento);
                setSolicitante(parseInt(response.data.row.created_by));
                setReceiverID(response.data.row.recebedor.id);
                setRowsLog(response.data.historic);
                setInputsValues((prevState) => ({...prevState, data_agendamento: date ? convertDateToBrazilianFormat(date) : "", hora_agendamento: time}))
                setDefaultWarehouse({label: response?.data?.row?.armazem?.nome, value: response?.data?.row?.armazem?.id});
                setSelectedWarehouse({label: response?.data?.row?.armazem?.nome, value: response?.data?.row?.armazem?.codigo});

                response.data.rows.map((row) => {
                    row.checked = false;

                    return row;
                });

                setRows(response.data.rows);
                setRowsDeleted([]);

                setCarrying(false);
            }
            ).catch((error) => {
                setCarrying(false);
                showMessageError(error?.response?.data);
            });

        setView(changeDisable(option));
    }

    function cancel() {
        history.push('/product_requests');
    }

    function generateTags() {
      setLabelMessageTag('Gerando');
      if (origin == '001') {
        api.post("/api/product_requests/setGenerateTags", listTagsReceipt)
        .then((response) => {
            setLabelMessageTag('');
            setListTagsReceipt(response.data.list);
            if (response.data.list_tags.length == 0) {
            toast.error('Nenhuma etiqueta gerada, selecione a quantidade!');
            } else {
            setListTagsToPrint(response.data.list_tags);
            setModalConfirmPrintTags(true);
            }
        }).catch((error) => {
            setLabelMessageTag('');
            showMessageError(error.response.data);
            setCarrying(false);
        });
      } else if (origin == '002') {
        api.post("/api/receipt_documents/setGenerateTags", listTagsReceipt)
        .then((response) => {
            setLabelMessageTag('');
            setListTagsReceipt(response.data.list);
            if (response.data.list_tags.length == 0) {
            toast.error('Nenhuma etiqueta gerada, selecione a quantidade!');
            } else {
            setListTagsToPrint(response.data.list_tags);
            setModalConfirmPrintTags(true);
            }
        }).catch((error) => {
            setLabelMessageTag('');
            showMessageError(error.response.data);
            setCarrying(false);
        });  
      }
    }

    async function setListTags(index, value) {
      let aux = [];
  
      listTagsReceipt.forEach((element, inx) => {
        if (inx == index) {
          element.quantity_generate = parseToFloat(value.toUpperCase());
        }
        aux.push(element)
      });
  
      setListTagsReceipt(() => aux);
    }

    function getPrintTag() {
      setLabelMessageTag('Imprimindo');
      setModalConfirmPrintTags(false);
      axios.post(
        baseURL + "api/tags/printList", listTagsToPrint,
        {
          responseType: 'blob',
          headers: {
            empresa: localStorage.empresa,
            usuario: localStorage.usuario
          }
        }
  
      ).then((response) => {
        setLabelMessageTag('');
        const content = response.headers['content-type'];
        download(response.data, 'etiquetas.pdf', content);
        setCarrying(false);
      }).catch((error) => {
        setLabelMessageTag('');
        console.log(error);
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }

    function setItemList(index, value) {
        let aux = [];

        conferenceFeatures.forEach((element, inx) => {
            if (inx === index) {
                element.valor = value.toUpperCase();
            }
            aux.push(element)
        });

        setConferenceFeatures(() => aux);
    }

    function verifyBalance() {
        if (selectedProduct.value === '') {
            return false;
        } else if (conferenceFeatures.length > 0) {
            conferenceFeatures.map((element) => {
                if (element.controls_balance === 'S' && (!element.valor || element.valor === '')) {
                    return false;
                }
            });
        }

        return true;
    }

    function filterList(term) {
        let aux_list = [];
        if (term && term !== '') {
            listOptionsMacSerie.map((element) => {
                if (element.serie.toLowerCase().includes(macSerieNumber) || element.mac.toLowerCase().includes(macSerieNumber)) {
                    aux_list.push(element);
                }
            });
        }
        setListOptionsMacSerieFiltred(aux_list);
    }

    function addItemList(item = null) {
        let isValid = false;
        if (item == null) {
            listOptionsMacSerie.map((element) => {
                if ((element.serie == macSerieNumber || element.mac == macSerieNumber) && (macSerieNumber && macSerieNumber != '')) {
                    listMacSerieSeleted.push(element);
                    setMacSerieNumber('');
                    setListOptionsMacSerieFiltred([]);
                    setItemFormQuantidade(listMacSerieSeleted.length);
                    isValid = true;
                }
            });
        } else {
            listMacSerieSeleted.push(item);
            setMacSerieNumber('');
            setListOptionsMacSerieFiltred([]);
            setItemFormQuantidade(listMacSerieSeleted.length);
            isValid = true;
        }

        if (isValid == false) {
            toast.error('Nenhum item encontrado!');
        }
    }

    function getBalance() {
        if (verifyBalance()) {
            let data = {
                data: removeEmptyValuesOfObject({
                    warehouse: selectedWarehouse.value || defaultWarehouse?.value,
                    product: selectedProduct.value,
                    client: cliente,
                    batch: selectedLot?.value,
                    pallet: selectedPallet?.value,
                    batch: selectedLot?.value,
                    pallet: selectedPallet?.value,
                    features: conferenceFeatures,
                })
            }

            setBalanceEngageInRequest(data.data);
            api.post("/api/products/getBalanceByProductFeatures", data)
                .then((response) => {
                    setQtdeProductFeature(response.data.product);
                    setQtdeSharedFeature(response.data.shared);
                    setQtdeEngageFeature(response.data.requested);
                    setListOptionsMacSerie(response.data.serie_mac);
                }).catch((error) => {
                    showMessageError(error.response.data);
                    setCarrying(false);
                });
        }
    }

    function setBalanceEngageInRequest(data) {
        var sum = 0;
        
        rows.map((element) => {
            const validaProduct = (data.product && data.product != '' && element.id_produto && element.id_produto != '');
            const validaClient = (data.client && data.client != '' && element.id_cliente && element.id_cliente != '');
            const validaWarehouse = (data.warehouse && data.warehouse != '' && element.armazem && element.armazem != '');
            const validaBatch = (data.batch && data.batch != '' && element.lote && element.lote != '');
            const validaPallet = (data.pallet && data.pallet != '' && element.etiqueta_palete && element.etiqueta_palete != '');
            
            if ((!validaProduct || (data.product == element.id_produto)) && 
                (!validaClient || (data.client == element.id_cliente)) && 
                (!validaWarehouse || (data.warehouse == element.armazem)) && 
                (!validaBatch || (data.batch == element.lote)) && 
                (!validaPallet || (data.pallet == element.etiqueta_palete))) {
                sum += parseFloat(element.quantidade);
            }
        });

        setQtdeEngageRequest(sum);
    }

    function remove() {
        api.delete("/api/product_requests/delete?id=" + id)
            .then(() => {
                toast.success(`Registro ${nameToReverseSeparation || "excluído"} com sucesso.`);
                history.push('/product_requests');
            }
            ).catch((error) => {
                showMessageError(error.response.data);
            });
    }

    function selectProduct() {
        api.get("/api/products/getFeaturesBalanceByProduct?product=" + selectedProduct.value + "&client=" + cliente)
            .then((response) => {
                setControlsPallet(response.data.controls_pallet);
                setControlsSerie(response.data.controls_serie);
                setControlsMac(response.data.controls_mac);
                setConferenceFeatures(response.data.features);
                setQtdeProduct(response.data.product);
                setQtdeEngage(response.data.requested);
            }).catch((error) => {
                showMessageError(error.response.data);
                setCarrying(false);
            });
    }

    function getProducts(){
        api
        .get(`/api/products/getSearchProduct?term=${searchListProducts?.split("-")[0].trim() || ""}`)
        .then((response) => {
            let products = [];

            response.data.list.map((product, index) => {
                if(index < 50){
                    products.push({label: `${product.codigo_produto} - ${product.descricao}`, value: product.id, unidade_medida: product.unidade_medida});
                }
            });

            products.unshift({label: "Selecione", value: "", unidade_medida: ""});

            setListProducts(products);
        })
        .catch((error) => {
            console.log(error);
        })
    }

    function getData() {
        api.get("/api/product_requests/getDataPage")
            .then((response) => {
                setListFeatures(response.data.features);
                setListStatus(response.data.status);

                setCarrying(false);
            }).catch((error) => {
                showMessageError(error.response.data);
                setCarrying(false);
            });
    }

    function getEmployees() {
        api
            .get(`/api/people/getList?funcionario=S`)
            .then((response) => {
                setEmployees(response?.data?.row);
            })
            .catch((error) => {
                setCarrying(false);
                if (error?.response) {
                    showMessageError(error?.response);
                }
            });
    }

    function getUsers() {
        api
            .get(`/api/users/getList?termSearch=${separatorName}`)
            .then((response) => {
                setCarrying(false);

                setUsers(response.data);
            })
            .catch((error) => {
                setCarrying(false);
                showMessageError(error.response.data);
            })
    }

    function searchClient(e) {
        api.get("/api/entry_documents/searchPeople?term=" + e.toLowerCase())
            .then((response) => {
                setListSearchCliente(response.data.people);
            }).catch((error) => {
                showMessageError(error.response.data);
            });
        setNomeCliente(e);
    }

    function selectClient(item) {
        setCliente(item.id);
        setNomeCliente(item.nome);

        setListSearchCliente([]);
    }

    function selectSeparator(separator) {
        setSeparator(separator.id);
        setSeparatorName(separator.nome);

        setUsers([]);
    }

    function openAddItem() {
        if (cliente && cliente != '') {
            setQtdeProduct('');
            setQtdeEngage('');
            setQtdeEngageRequest('');
            setQtdeProductFeature('');
            setQtdeSharedFeature('');
            setQtdeEngageFeature('');
            setConferenceFeatures([]);
            setListOptionsMacSerie([]);
            setListMacSerieSeleted([]);
            setItemFormQuantidade('');
            setSelectedLot("");
            setMacSerieNumber('');
            setSelectedPallet("");
            setSelectedProduct({label: "", value: "", unidade_medida: ""});
            setSelectedUnit({label: "", value: "", unidade_medida: ""});
            setControlsPallet('');
            setControlsSerie('');
            setControlsMac('');

            setSeparationOpenWithoutTag(true);
        } else {
            toast.error('Selecione o cliente antes de adicionar itens à requisição!')
        }
    }

    function validateItem() {
        if (selectedProduct.label && item_form_quantidade) {
            return true;
        } else {
            toast.error('Preencha todos os campos com * antes de adicionar item.');
            return false;
        }
    }

    function addItem() {
        if (validateItem()) {
            let list_aux = [];
            
            let newRow = {
                id_cliente: cliente,
                armazem: selectedWarehouse.value || defaultWarehouse?.value,
                id_produto: selectedProduct.value,
                label_produto: selectedProduct.label,
                lote: selectedLot.value,
                etiqueta_palete: selectedPallet.value,
                quantidade: item_form_quantidade,
                id_caracteristica_produto: conferenceFeatures,
                list_serie_mac: listMacSerieSeleted,
                unidade_medida: selectedUnit?.value
            };
            
            conferenceFeatures.map((element) => {
                list_aux.push({
                    chave: element.chave,
                    descricao: element.descricao,
                    valor: element.valor,
                    id_produto: selectedProduct.value
                });
            });

            api.post("/api/product_requests/setValidateItemsFeatures", { row: newRow, rows: rows, features: list_aux }).then(() => {
                rows.push(newRow);
                setAddedItems('S');
                setRows(rows);
                setSeparationOpenWithoutTag(false);
            }).catch((error) => {
                showMessageError(error.response.data);
                setCarrying(false);
            });
        }
    }

    function viewLogFeatures(item) {
        setLogFeature(item.id_caracteristica_produto);
        setModalLogFeaturesOpen(true);
    }

    function getDataFields(item) {
        setFields(item.list_serie_mac);
        setModalFieldsOpen(true);
    }

    function getDataFeatures(item, index) {
        let completedItens = [];

        item.id_caracteristica_produto.map((character) => {
            if (character.valor !== "") {
                completedItens.push(character);
            }
        })

        item.id_caracteristica_produto = completedItens;

        setFeature(item.id_caracteristica_produto);
        setItemId(item);
        setIndex(index);
        setModalFeaturesOpen(true);
    }

    function getDataLog(item) {
        api.get("/api/getLogSeparation?id=" + item.id)
            .then((response) => {
                setListLogSeparation(response.data.list);
                setModalLog(true);
            }).catch((error) => {
                showMessageError(error.response.data);
            });
    }

    function getDataSeparation(item) {
        setShowSeparationModal(true);
        setSeparations(item.separacao_items);
    }

    function openModalTags() {
        if (!idPreview || addedItems == 'S') {
            setModalConfirmTags(true);
        } else {
            getListTags();
        }
    }
    
    function saveAndGetListTags() {
        setModalConfirmTags(false);
        setCarrying(true);

        if (!validForm()) {
            setCarrying(false);
            return false;
        }

        const data = {
            row: {
                id_cliente: cliente,
                observacao: observacao,
                status: status,
                data: inputsValues.data_solicitacao,
                hora: hora_solicitacao,
            },
            rows: rows,
            rows_deleted: rows_deleted,
        };

        if(defaultWarehouse?.value){
            data.row.armazem = defaultWarehouse?.value;
        }

        if(inputsValues.data_agendamento !== "" && inputsValues.hora_agendamento){
            data.row.agendamento = `${inputsValues.hora_agendamento} ${convertDateToBrazilianFormat(inputsValues.data_agendamento)}`
        }

        if (getParameter("DEFINE_USUARIO_REQ") === "T") {
            data.row.usuario_responsavel = separator;
        }

        if (idPreview) {
            data.row.id = idPreview;
            api.put("/api/product_requests/put", data).then(() => {
                getListTags();
                setCarrying(false);
            }).catch((error) => {
                showMessageError(error.response.data);
                setCarrying(false);
            });
        } else {
            api.post("/api/product_requests/post", data).then((response) => {
                setIdPreview(response.data.id);
                getOne(response.data.id, option);
                getListTags(response.data.id);
            }).catch((error) => {
                showMessageError(error.response.data);
                setCarrying(false);
            });
        }
    }
    
    function getListTags(param = idPreview) {
      let id_origin_tag = param;
      let origin_tag = '002';

      if (entreposto && entreposto != '') {
        id_origin_tag = entreposto;
        origin_tag = '001';
      }
      
      setListTagsReceiptByProduct([]);
      setGenerationTags(() => ({ label_product: '', id_product: '', quantity: 0 }));
      api.get("/api/tags/getSummaryTagsByOrigin?id=" + id_origin_tag + "&origin=" + origin_tag)
        .then((response) => {
          setListTagsReceipt(response.data.list_tags);
          setLabelMessageTag('');
          setModalTagsReceipt(true);
        }).catch((error) => {
          showMessageError(error.response.data);
          setCarrying(false);
        });
    }

    function finishItem(item) {
        //API original: `/api/product_requests/finishItem?id=${item.id}`
        //API para o futuro: `/api/products_requests/${id}/itens/${item.id}/finalizar`
        api.put(`/api/products_requests/${id}/itens/${item.id}/finalizar`)
            .then((response) => {
                setNomeCliente(response.data.row.cliente.razao_social);
                setCliente(response.data.row.cliente.id);
                setObservacao(response.data.row.observacao);
                setStatus(response.data.row.status);
                setInputsValues((prevState) => ({...prevState, data_solicitacao: response.data.row.data}));
                setHoraSolicitacao(response.data.row.hora);

                setRows(response.data.rows);
                setRowsDeleted([]);

                setCarrying(false);
            }).catch((error) => {
                showMessageError(error.response.data);
            });
    }

    function removeItemListSerieMac(index) {
        let aux_rows = [];

        listMacSerieSeleted.map((element, idx) => {
            if (idx !== index) {
                aux_rows.push(element);
            }
        });
        setItemFormQuantidade(aux_rows.length);
        setListMacSerieSeleted(aux_rows);
    }

    function removeItem(index) {
        let aux_rows = [];
        let aux_rows_deleted = rows_deleted;

        rows.map((element, idx) => {
            if (idx === index) {
                aux_rows_deleted.push(element);
            } else {
                aux_rows.push(element);
            }
        });

        setRows(aux_rows);
        setRowsDeleted(aux_rows_deleted);
    }

    function saveFeatures() {
        let list_aux = [];
        feature.map((element) => {
            list_aux.push({
                chave: element.chave,
                descricao: element.descricao,
                valor: element.valor,
                id_produto: itemId.id_produto
            });
        });

        api.post("/api/product_requests/setValidateItemsFeatures", { features: list_aux })
            .then(() => {
                rows[index_aux].id_caracteristica_produto = feature;
                setModalFeaturesOpen(false);
            }
            ).catch((error) => {
                error.response.data.message.map((error) => {
                    toast.error(error);
                });
                setCarrying(false);
            });
    }

    function openMakeReturn() {
        let aux_list = [];
        setObservationReturn('Devolução da requisição ' + id);
        rows.map(element => {
            if (element.checked) {
                aux_list.push(element);
            }
        });

        if (aux_list.length > 0) {
            api.post("/api/product_requests/getReturnItems", { items: aux_list })
                .then((response) => {
                    setListReturn(response.data.list);
                    setModalMakeReturn(true);
                }).catch((error) => {
                    error.response.data.error.info.map((error) => {
                        toast.error(error);
                    });
                    setCarrying(false);
                });
        } else {
            toast.error('Selecione pelo menos um item para devolução.');
        }
    }

    function setItemReturn(index, value, field) {
        let aux = [];

        listReturn.forEach((element, inx) => {
            if (inx === index) {
                element[field] = setMaskDecimal(value);
            }
            aux.push(element)
        });

        setListReturn(() => aux);
    }

    function changeItem(e) {
        setRows(rows.map((element) => {
            if (element.id === parseInt(e.target.value)) {
                element.checked = !element.checked;
            }

            return element;
        }));
    }

    function getUnits(){
        api
        .get(`/api/units/getList?produto=${selectedProduct?.value}`)
        .then((response) => {
            let adaptedUnitsValueToSelectLibModel = [];

            response?.data?.map((unit) => {
                adaptedUnitsValueToSelectLibModel.push({label: unit?.DESCRICAO, value: unit?.ID});
            });

            adaptedUnitsValueToSelectLibModel.unshift({label: "Selecione", value: ""});

            setListUnits(adaptedUnitsValueToSelectLibModel);
        })
        .catch((error) => {
          console.log(error);
          showMessageError(error.response.data);
        })
        .finally(() => {
            setCarrying(false);
        });
    }

    function verifyCharacters(item) {
        let valueExists = false;

        item.id_caracteristica_produto.map((character) => {
            if (character.valor) {
                valueExists = true;
            }
        })

        return valueExists;
    }

    function printLogs() {
        let params = `id=${id}`;
        setCarryingExcel(true);
        api
            .get(`/api/logs/productRequest?${params}`, { responseType: 'blob' })
            .then((response) => {
                const content = response.headers['content-type'];
                const dateAndHour = new Date();
                const formatedDateAndHour = format(dateAndHour, 'dd/MM/yyyy HH:mm:ss');

                download(response.data, `LOG_REQUISICAO_${id} ${formatedDateAndHour}.xlsx`, content);

                setCarryingExcel(false);
            })
            .catch((error) => {
                setCarryingExcel(false);

                showMessageError(error.response.data);
            });
    }

    function dispatch() {
        const closeCurrentModalAndOpenAlertModalOfDispatch = (message, isEnd) => {
            if(isEnd){
                setModalDispatch(false);
            }
            setModalAlertDispatch({open: true, message: message, isEnd: isEnd});
        }

        if(!palletToDispatch){
            setModalAlertDispatch({open: true, message: "Não é possível realizar uma expedição com o valor vazio", isEnd: false});

            return false;
        }

        api
            .put(`/api/products_requests/${id}/expedir/${palletToDispatch}`)
            .then((response) => {
                const isEnd = (response.data.status === "013");
                setPalletToDispatch("");

                if(isEnd){
                    closeCurrentModalAndOpenAlertModalOfDispatch("A expedição foi finalizada com sucesso!", isEnd);
                    setStatus(response.data.status);

                    return true;
                }
                
                toast.success(response?.data?.message);

                return true;
            })
            .catch((error) => {
                setCarrying(false);
                closeCurrentModalAndOpenAlertModalOfDispatch(error?.response?.data?.message);
            });
    }

    function getWarehouses() {
        api
            .get("/api/warehouses/getList")
            .then((response) => {
                let warehousesOptions = [];

                response.data.map((warehouse) => {
                    warehousesOptions.push({ label: warehouse.descricao, value: parseInt(warehouse.id) });
                });
                warehousesOptions.unshift({ label: "Selecione", value: "" });

                setWarehouses(warehousesOptions);

                if (response.data.length === 1) {
                    setSelectedWarehouse({label: warehousesOptions?.label, value: warehousesOptions?.value});
                }

                setCarrying(false);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    function getDataToLotAndPalletAPI(batchValue, palletValue){
        const data = {
            row: {
                client: cliente,
                warehouse: selectedWarehouse.value || defaultWarehouse?.value,
                product: selectedProduct.value,
                features: conferenceFeatures,
                batch: batchValue?.value ? batchValue?.value : batchValue,
                pallet: palletValue?.value ? palletValue?.value : palletValue
            }
        }

        console.log(data)

        return data;
    }

    function getLots(batchValue, palletValue){
        const newCancelToken = axios.CancelToken.source();
        setCancelToken(newCancelToken);

        api
        .post("/api/products/lotes", getDataToLotAndPalletAPI(batchValue, palletValue), {
            cancelToken: newCancelToken.token
        })
        .then((response) => {
            if(!newCancelToken.token.reason){
                let convertedDataInSelectModel = [];

                response.data.dados.map((data) => {
                    convertedDataInSelectModel.push({label: data.LOTE, value: data.LOTE});
                });
    
                convertedDataInSelectModel.unshift({label: "Selecione", value: ""});
    
                setListBatchs(convertedDataInSelectModel);
            }
        })
        .catch((error) => {
            console.log(error);
            showMessageError(error?.response?.message);
        })
    }

    function getPallets(batchValue, palletValue){
        api
        .post("/api/products/paletes", getDataToLotAndPalletAPI(batchValue, palletValue))
        .then((response) => {
            let convertedDataInSelectModel = [];

            response.data.dados.map((data) => {
                convertedDataInSelectModel.push({label: data.ETIQUETA_PALETE, value: data.ETIQUETA_PALETE});
            });

            convertedDataInSelectModel.unshift({label: "Selecione", value: ""});

            setListPallets(convertedDataInSelectModel);
        })
    }

    function getItens() {
        api
            .get(`/api/products_requests/${id}/itensExpedir`)
            .then((response) => {
                setItens(response.data.itens);
            })
            .catch((error) => {
                console.log(error);
                showMessageError(error.response.data);
            });
    }

    useEffect(() => {
        getEmployees();

        if(getParameter("DEFINE_ARMAZEM_REQ") === "T"){
            getWarehouses();
        }
    }, []);

    useEffect(() => {
        setTimeout(() => {
            if (separatorName) {
                return getUsers();
            }

            return setUsers([]);
        }, 2000);
    }, [separatorName]);

    useEffect(() => {
        if (modalListPallets) {
            getItens();
        }
    }, [modalListPallets]);

    useEffect(() => {
        getProducts();
    }, [searchListProducts]);

    useEffect(() => {
        setStatus('001');
        setInputsValues((prevState) => ({...prevState, data_solicitacao: dateToday}));
        setHoraSolicitacao(hoursNow);
        getEmployees("funcionario=S");
        getData();
    }, []);

    useEffect(() => {
        if (nome_cliente === getParameter('CLIENTE_PADRAO')) {
            api.get("/api/entry_documents/searchPeople?term=" + nome_cliente.toLowerCase())
                .then((response) => {
                    setCliente(response?.data?.people[0]?.id);
                })
                .catch((error) => {
                    showMessageError(error.response.data);
                });
        }
    }, [nome_cliente]);


    useEffect(() => {
        if (id) {
            setIdPreview(id);
            getOne(id, option);
        }
    }, [id, option]);


    useEffect(() => {
        if (id && ['007', '009'].indexOf(status) > -1 && showModalDeliverSignature) {
            getSignature();
        }
    }, [id, status, showModalDeliverSignature]);

    useEffect(() => {
        if(selectedProduct.value){
            selectProduct();
            getUnits();
        }
    }, [selectedProduct]);

    useEffect(() => {
        if(lotInputValue){
            getLots(lotInputValue, selectedPallet);
        }
    }, [lotInputValue]);

    useEffect(() => {
        return () => {
            if(cancelToken){
            cancelToken.cancel('Componente desmotando');
            }
        }
    }, [cancelToken]);

    return (
        <div>
            <Header />
            <Division />
            <Lateral />
            <ReactTooltip />

            <ModalConfirmation 
                state={showModals.confirmDelete} 
                setState={setShowModals} 
                stateName={'confirmDelete'} 
                custom={custom('500px', '250px')} 
                title={'Deseja realmente excluir esta requisição?'} 
                action={remove} 
                param={''} 
            />

            {carrying && <div className="content">
                <div className="divCarrying">
                    <span>Carregando..</span>
                    <FaCog icon="spinner" className="spinner" />
                </div>
            </div>}
            {!carrying && <div className="content">
                <Title name="Cadastro de Requisição">
                    <Link onClick={() => window.history.back()}>
                        <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
                    </Link>
                </Title>
                <div className="container">
                    <form className="form-profile customers">
                        <div className="containerGroupData">
                            <h2>Dados Cadastrais - {id}</h2>
                            <hr></hr>
                            <div className="divGroup" style={{display: "flex", alignItems: "center"}}>
                                <div className="formDiv">
                                    <label>Cliente</label>&nbsp;<label className="required">*</label><br />
                                    <input type="text" placeholder="Cliente" value={nome_cliente}
                                        onChange={(e) => searchClient(e.target.value)} maxLength="60"
                                        disabled={view || rows.length > 0 || (['001'].indexOf(status) === -1 && (parseInt(localStorage.getItem("usuario")) !== solicitante || !getPermission("OPERACOES - REQUISICOES - EDITA TERCEIROS")))} />
                                    <ul className="dropdown-menu" id="transportDatalist" style={{zIndex: "11"}}>
                                        {listSearchCliente.map((item, index) => (
                                            <li key={index} onClick={() => selectClient(item)}>
                                                <a>{item.nome}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                {getParameter("DEFINE_USUARIO_REQ") === "T" && <div className="formDiv">
                                    <label>Separador</label>&nbsp;<label className="required">*</label><br />
                                    <input type="text" value={separatorName} placeholder="Separador" onMouseOver={() => { selectLib.current.style.cursor = "pointer" }} onClick={() => checkIfArrayAlreadyWasListed(users, setUsers, getUsers)} onChange={(e) => setSeparatorName(e.target.value)} maxLength="60" disabled={view} ref={selectLib} />
                                    <div style={{ position: "relative" }}>
                                        <ul className="dropdown-menu" id="transportDatalist" style={{ width: "100%", color: "#2c3e50", fontSize: "15px" }}>
                                            {users.map((user, index) => (
                                                <li key={index} onClick={() => selectSeparator(user)}>
                                                    <a>{user.nome}</a>
                                                </li>
                                            ))}
                                        </ul>
                                        <IoIosArrowDown style={{ position: "absolute", right: "0", bottom: "0", marginBottom: "0.6rem", marginRight: "0.15rem", width: "0.8rem", fontWeight: "700" }} />
                                    </div>
                                </div>}
                                <div className="formDiv">
                                    <label>Status</label>&nbsp;<label className="required">*</label><br />
                                    <select value={status} onChange={(e) => setStatus(e.target.value)} disabled={true}>
                                        <option value="">Selecione</option>
                                        {listStatus.map((item, index) => (
                                            <option key={index} value={item.chave}>{item.chave} - {item.descricao}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="formDiv">
                                    <label>Data do Agendamento</label><br />
                                    <InputDate filters={inputsValues} setFilters={setInputsValues} propertyFilter="data_agendamento" disabled={(view || ['001'].indexOf(status) === -1 && (!currentUserIsRequester || !userHasAllPermissions))} />
                                </div>
                                <div className="formDiv">
                                    <label>Hora do Agendamento</label><br />
                                    <input 
                                        type="time" 
                                        value={inputsValues.hora_agendamento} 
                                        onChange={(event) => setInputsValues((prevState) => ({...prevState, hora_agendamento: event.target.value}))} 
                                        disabled={view || ['001'].indexOf(status) === -1 && (!currentUserIsRequester || !userHasAllPermissions)} 
                                    />
                                </div>
                            </div>
                            <div className="divGroup" style={{display: "flex", alignItems: "center"}}>
                                <div className="formDiv">
                                    <label>Data</label><br />
                                    <InputDate filters={inputsValues} setFilters={setInputsValues} propertyFilter="data_solicitacao" disabled />
                                </div>
                                <div className="formDiv">
                                    <label>Hora</label><br />
                                    <input type="text" placeholder="##:##:##" value={hora_solicitacao}
                                        onChange={(e) => setHoraSolicitacao(setMaskGeneric(e.target.value, "##.##.##"))}
                                        maxLength="8" disabled={true} />
                                </div>
                                {id &&
                                    <div className="formDiv">
                                        <label>Número Documento</label><br />
                                        <input type="text" value={documentNumber} disabled={true} />
                                    </div>
                                }
                                {getParameter("DEFINE_ARMAZEM_REQ") === "T" && 
                                    <div className="formDiv">
                                        <label>Armazém</label><br />
                                        <Select value={defaultWarehouse} options={warehouses} styles={defaultStylesSelectLib} onChange={(event) => {setDefaultWarehouse(event); setSelectedWarehouse(event)}} isDisabled={view || rows?.length > 0} />
                                    </div>
                                }
                                <div className="formDiv">
                                    <label>Observacao</label><br />
                                    <input type="text" placeholder="Observação" value={observacao}
                                        onChange={(e) => setObservacao(e.target.value)} maxLength="200"
                                        disabled={view || ['001'].indexOf(status) === -1 && (parseInt(localStorage.getItem("usuario")) !== solicitante || !getPermission("OPERACOES - REQUISICOES - EDITA TERCEIROS"))} />
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className="divGroup">
                            <div className="formDivList">
                                <div className="containerGroupData">
                                    <h2>Itens&nbsp;<label className="required">*</label></h2>
                                    <hr></hr>
                                    <table>
                                        <thead>
                                            <tr>
                                                {tableHeaders.map((tableHeader, index) => {
                                                    if (tableHeader.validation) {
                                                        return (
                                                            <th key={index} colSpan={tableHeader.scope}>{tableHeader.name}</th>
                                                        )
                                                    }
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rows.map((form_item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        {['007'].indexOf(status) > -1 && <td data-label="#">
                                                            <input
                                                                type="checkbox"
                                                                checked={form_item.checked}
                                                                value={form_item.id}
                                                                onChange={changeItem}
                                                                disabled={
                                                                    form_item.quantity_available_return <= 0
                                                                    ||
                                                                    parseInt(localStorage.getItem("usuario")) !== solicitante && !getPermission("OPERACOES - REQUISICOES - EDITA TERCEIROS")
                                                                }
                                                            />
                                                        </td>}
                                                        <td colSpan={2}>
                                                            <div className="formDiv">
                                                                {form_item.label_produto}
                                                            </div>
                                                        </td>
                                                        <td>{form_item?.produto?.codigos_barra[0]?.unidade_medida?.UNIDADE || selectedUnit?.label}</td>
                                                        {getParameter('DEFINE_SERIE_MAC_REQ') == 'T' && <td>
                                                            {<button type="button" className="buttonTable"
                                                                onClick={() => getDataFields(form_item, index)}>
                                                                Ver Série/MAC
                                                            </button>}
                                                        </td>}
                                                        {listFeatures.length > 0 && <td>
                                                            {verifyCharacters(form_item) &&
                                                                <button type="button" className="buttonTable"
                                                                    onClick={() => getDataFeatures(form_item, index)}>
                                                                    Ver características
                                                                </button>
                                                            }
                                                        </td>}
                                                        <td>{form_item.quantidade}</td>
                                                        <td>{form_item.qtde_separada}</td>
                                                        <td>{form_item.qtde_conferida}</td>
                                                        {['007'].indexOf(status) > -1 && <td>
                                                            {form_item.qtde_pendente_devolucao}
                                                        </td>}
                                                        {['007'].indexOf(status) > -1 && <td>
                                                            {form_item.qtde_devolvida}
                                                        </td>}
                                                        {['007'].indexOf(status) > -1 && <td>
                                                            {form_item.quantity_available_return}
                                                        </td>}
                                                        <td>{form_item.qtde_eliminada}</td>
                                                        {id && <td>
                                                            <button type="button" className="buttonTable"
                                                                onClick={() => getDataLog(form_item)}>Ver log
                                                            </button>
                                                        </td>}
                                                        {id && !(['001', '002', '003', '004'].indexOf(status) > -1) && <td>
                                                            <button type="button" className="buttonTable"
                                                                onClick={() => getDataSeparation(form_item)}>
                                                                Ver Separação
                                                            </button>
                                                        </td>}
                                                        {['001', '002', '008'].indexOf(status) > -1 &&
                                                            <td className='collumOption' style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%", marginTop: "0.5rem" }}>
                                                                {['001'].indexOf(status) > -1 && <Link className="action" onClick={() => removeItem(index)}>
                                                                    <FaTrash color="#000" size={17} />
                                                                </Link>}
                                                                {getPermission('OPERACOES - REQUISICOES - ELIMINAR RESÍDUOS') && ['002', '008'].indexOf(status) > -1 && form_item.status !== 'F' &&
                                                                    <Link className="action" style={{ marginRight: '2.5rem' }}
                                                                        data-tip="Eliminar Resíduo"
                                                                        onClick={() => finishItem(form_item)}>
                                                                        <ReactTooltip />
                                                                        <FaArchive color="#000" size={17} />
                                                                    </Link>}
                                                            </td>}
                                                    </tr>
                                                )
                                            })}
                                            {rows.length === 0 && <tr>
                                                <td colSpan={tableHeaders.filter((tableHeader) => tableHeader.validation).length + 1}><label className='required'>Nenhum registro encontrado!</label></td>
                                            </tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="formDiv" style={{ display: "flex", gap: "0.5rem" }}>
                            {!view &&
                                <button type="submit" className="buttonSubmit" onClick={save} disabled={view}>Salvar</button>}
                            {!view &&
                                <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>}
                            {(!view && id && (parseInt(localStorage.getItem("usuario")) === solicitante || getPermission("OPERACOES - REQUISICOES - SUPER APROVACAO")) && (['001', '002'].indexOf(status) > -1 || (getParameter('Validar Estoque') === 'F' && ['006', '011'].indexOf(status) > -1))) &&
                                <button type="button" style={{
                                    backgroundColor: '#001675',
                                    marginLeft: '15px',
                                    width: reverseToERPParamater ? '10rem' : '',
                                    color: '#FFF'
                                }} className="buttonRemove" onClick={() => setShowModals((prevState) => ({ ...prevState, confirmDelete: true }))}
                                    disabled={view}>{reverseToERPParamater || "Excluir"}</button>}
                            {(id || parseInt(localStorage.getItem("usuario")) === solicitante) &&
                                <button type="button"
                                    style={{
                                        backgroundColor: `${carryingExcel ? '#001fff' : ''}`,
                                        width: `${carryingExcel ? '7.5rem' : ''}`,
                                        marginLeft: '1rem'
                                    }}
                                    className="buttonSubmit"
                                    onClick={printLogs}>
                                    {carryingExcel ? 'Imprimindo log...' : 'Imprimir log'}
                                </button>}
                            {checkIfButtonOfAddItemMustToBeDisplayed &&
                                <button type="button" className="buttonTab" onClick={openAddItem}>Adicionar Item</button>}
                            {id && ['006', '007', '008', '009', '010', '011'].indexOf(status) > -1 && getPermission("OPERACOES - REQUISICOES - ENTREGAR") &&
                                <button type='button' onClick={() => setShowModalDeliverSignature(true)}
                                    className="buttonTab">
                                    {['006'].indexOf(status) > -1 ? 'Entregar' : 'Consultar Entrega'}
                                </button>
                            }
                            {getPermission('OPERACOES - REQUISICOES - APROVACAO') && ['002'].indexOf(status) > -1 &&
                                <button type="button" className="buttonTab"
                                    onClick={() => setModalReverseAproveSeparation(true)}>Estornar
                                    Aprovação</button>}
                            {getPermission('OPERACOES - SEPARACAO') && ['002', '008'].indexOf(status) > -1 &&
                                <button type="button" className="buttonTab"
                                    onClick={() => setModalStartSeparation(true)}>Iniciar Separação</button>}
                            {getPermission('OPERACOES - SEPARACAO') && ['004', '005'].indexOf(status) > -1 &&
                                <button type="button" className="buttonTab"
                                    onClick={() => setModalPauseSeparation(true)}>Pausar Separação</button>}
                            {getPermission('OPERACOES - SEPARACAO - FINALIZAR SEPARACAO') && ['009'].indexOf(status) > -1 &&
                                <button type="button" className="buttonTab"
                                    onClick={() => setModalFinishSeparation(true)}>Finalizar</button>}
                            {(solicitante == localStorage.usuario || getPermission('OPERACOES - REQUISICAO DEVOLUCAO - SUPER CADASTRO')) && getPermission('OPERACOES - REQUISICOES - INICIAR DEVOLUCAO') && ['007', '010'].indexOf(status) > -1 &&
                                <button type="button" className="buttonTab" onClick={openMakeReturn}>Solicitar Devolução</button>}
                            {getPermission('OPERACOES - REQUISICOES - EXPEDIR') && ['010', '012'].indexOf(status) > -1 &&
                                <button type="button" className="buttonSubmit" onClick={() => setModalDispatch(true)}>Expedir</button>
                            }
                            <button type="button" className="buttonTab pullRight" onClick={openModalTags}>Etiquetas</button>
                        </div>
                    </form>
                </div>
                <ListLog listItems={rows_log} setViewLog={setViewLog} setModalViewLog={setModalViewLog} />
            </div>}
            
            <Modal
                isOpen={modalDispatch}
                onRequestClose={() => setModalDispatch(false)}
                style={custom("33.3%", "auto")}
                className="modal-dispatch"
                contentLabel="Modal para expedição"
                ariaHideApp={false}
                keepMounted
            >
                <div className="modal-dispatch__info formDiv">
                    <label className="modal-dispatch____label">Palete para expedir</label><br />
                    <div className="modal-dispatch___input">
                        <input type="text" value={palletToDispatch} onChange={(e) => setPalletToDispatch(e.target.value)} onKeyDown={(e) => e.key === "Enter" ? dispatch() : {}} placeholder="Palete para expedir" onBlur={() => addFocusToTheElement(buttonToConfirmDispatch)} />
                        <button className="modal-dispatch___button buttonSubmit" onClick={dispatch} ref={buttonToConfirmDispatch}>Confirmar</button>
                    </div>
                </div>
                <div className="modal-dispatch__buttons">
                    <button className="modal-dispatch___button buttonSubmit" onClick={() => setModalDispatch(false)} style={{ width: "25%" }}>Fechar</button>
                    <button className="modal-dispatch___button buttonSubmit" onClick={() => setModalListPallets(true)}>Consultar Paletes</button>
                </div>
            </Modal>
            <Modal
                isOpen={modalAlertDispatch.open}
                onRequestClose={() => setModalAlertDispatch((prevState) => ({...prevState, open: false}))}
                style={custom("33.3%", "auto")}
                className="modal-alert-dispatch-end"
                contentLabel="Modal de aviso de finalização de expedição"
                ariaHideApp={false}
                keepMounted
            >
                <h2 className="modal-alert-dispatch-end__title">{modalAlertDispatch.message}</h2>
                <button className="modal-alert-dispatch-end__button" onClick={() => setModalAlertDispatch((prevState) => ({...prevState, open: false}))}>{modalAlertDispatch.isEnd ? "Fechar" : "Voltar"}</button>
            </Modal>
            <Modal
                isOpen={modalListPallets}
                onRequestClose={() => setModalListPallets(false)}
                style={custom("50%", "50%")}
                className="modal-list-pallets"
                contentLabel="Modal para listar paletes"
                ariaHideApp={false}
                keepMounted
            >
                <div className="modal-list-pallets__header">
                    <h2 className="modal-list-pallets___title">Paletes</h2>
                    <button className="modal-list-pallets___button" onClick={() => setModalListPallets(false)}>Voltar</button>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>Palete</th>
                            <th>Situação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {itens.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td>{item.palete}</td>
                                    <td>{item?.expedicao ? "Expedido" : "Não Expedido"}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </Modal>
            <Modal
                isOpen={modalEditInfo}
                onRequestClose={closeModalInfo}
                style={customShortModal}
                contentLabel="Itens"
                ariaHideApp={false}
                keepMounted
            >
                <div>
                    <div className="divGroup">
                        <table>
                            <thead>
                                <tr>
                                    <th>Série</th>
                                    <th>MAC</th>
                                    <th>Opções</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listMacSerieSeleted?.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td scope="col">{item.serie}</td>
                                            <td scope="col">{item.mac}</td>
                                            <td scope="col">
                                                <Link className="action" onClick={() => removeItemListSerieMac(index)}>
                                                    <FaTrash color="#000" size={17} />
                                                </Link>
                                            </td>
                                        </tr>
                                    )
                                })}
                                {listMacSerieSeleted.length == 0 && <tr>
                                    <td colSpan={3}><label className='required'>Nenhum registro encontrado!</label></td>
                                </tr>}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div style={{ marginTop: '10px' }}>
                    <button onClick={closeModalInfo} className='cancelButton inputSm'>Fechar</button>
                </div>
            </Modal>
            <Modal
                isOpen={modalSeparationOpenWithoutTag}
                onRequestClose={closeModal}
                style={customHalfModal}
                contentLabel="Conferência"
                ariaHideApp={false}
                keepMounted
            >
                <div>
                    {qtdeProduct !== '' && <div><label>Saldo disponível: {qtdeProduct}</label></div>}
                    {qtdeEngage !== '' && <div><label>Saldo empenhado: {qtdeEngage}</label></div>}

                    <div className="input-group">
                        <div className="formDiv" style={{width: "66.6%"}}>
                            <label>Produto</label>&nbsp;<label className="required">*</label><br />
                            <Select
                                options={listProducts}
                                value={selectedProduct}
                                onBlur={getBalance}
                                onInputChange={(value) => setSearchListProducts(value)}
                                onChange={(value) => setSelectedProduct(value)}
                                placeholder="Produto" styles={customStyleSelect}
                            />
                        </div>
                        <div className="formDiv" style={{width: "33.3%"}}>
                            <label>Unidade de Medida</label>
                            <Select
                                placeholder="Unidade de Medida"
                                value={selectedUnit}
                                options={listUnits}
                                onChange={(value) => setSelectedUnit(value)}
                                styles={customStyleSelect}
                            />
                        </div>
                    </div>
                    {defineWarehouseIsAllowed === "T" && 
                        <div className="formDiv">
                            <label>Armazém</label><br />
                            <Select 
                                options={warehouses} 
                                value={selectedWarehouse} 
                                onChange={(value) => setSelectedWarehouse(value)} 
                                onBlur={getBalance} 
                                placeholder="Armazém" styles={customStyleSelect} 
                                isDisabled={defaultWarehouse?.value} 
                            />
                        </div>
                    }

                    {conferenceFeatures.length > 0 && conferenceFeatures.map((item, index) => (
                        <div className="formDiv">
                            <label>{item.descricao}</label>&nbsp;{item.mandatory === 'S' &&
                                <label className="required">*</label>}<br />
                            <input type="text" placeholder={item.descricao} value={conferenceFeatures[index].valor}
                                onBlur={() => {conferenceFeatures[index]?.valor && getBalance()}} onChange={(e) => setItemList(index, e.target.value)}
                                maxLength="30"
                                disabled={view || (id && parseInt(localStorage.getItem("usuario")) !== solicitante && !getPermission("OPERACOES - REQUISICOES - EDITA TERCEIROS"))} />
                        </div>
                    ))}
                    {controls_pallet == 'S' && <div className="divGroup">
                        <div className="formDiv">
                            <label>Etiqueta Palete</label><br />
                            <Select 
                                options={listPallets} 
                                styles={customStyleSelect} 
                                value={selectedPallet} 
                                onBlur={getBalance} 
                                placeholder="Etiqueta Palete" 
                                onInputChange={(value) => getPallets(selectedLot, value)} 
                                onChange={(value) => setSelectedPallet(value)} 
                                disabled={id && parseInt(localStorage.getItem("usuario")) !== solicitante && !getPermission("OPERACOES - REQUISICOES - EDITA TERCEIROS")} 
                            />
                        </div>
                    </div>}

                    {defineLotIsAllowed == 'T' && <div className="divGroup">
                        <div className="formDiv">
                            <label>Lote</label><br />
                            <Select 
                                options={listBatchs} 
                                styles={customStyleSelect}
                                value={selectedLot} 
                                onBlur={getBalance} 
                                placeholder="Lote" 
                                onInputChange={(value) => setLotInputValue(value)}
                                onChange={(value) => setSelectedLot(value)} 
                                disabled={id && parseInt(localStorage.getItem("usuario")) !== solicitante && !getPermission("OPERACOES - REQUISICOES - EDITA TERCEIROS")} 
                            />
                        </div>
                    </div>}

                    {(controls_serie == 'S' || controls_mac == 'S') && <div className="divGroup">
                        <div className="formDiv">
                            <label>Número Série/MAC</label><br />
                            <input type="text" placeholder="Número Série/MAC" onBlur={getBalance} value={macSerieNumber} onChange={(e) => { setMacSerieNumber(e.target.value); filterList(e.target.value) }} maxLength="30" />
                            <ul className="dropdown-menu" id="productDatalist">
                                {listOptionsMacSerieFiltred?.map((item, index) => (
                                    <li key={index} onClick={() => addItemList(item)}>
                                        <a>Série: {item.serie} | MAC: {item.mac}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="formDiv">
                            <Link className="action" onClick={() => addItemList(null)}>
                                <FaPlus color="#000" size={17} />
                            </Link>
                            <Link className="action" onClick={() => { setSeparationOpenWithoutTag(false); setModalEditInfo(true) }} style={{ marginLeft: "10px" }}>
                                <FaSearch color="#000" size={17} /> <label className='labelIcon'>Ver lista</label>
                            </Link>
                        </div>
                    </div>}

                    {qtdeProductFeature != null && qtdeProductFeature !== '' && <div><label>Saldo disponível: {qtdeProductFeature}</label></div>}
                    {qtdeSharedFeature != null && qtdeSharedFeature !== '' && <div><label>Saldo disponível compartilhado: {qtdeSharedFeature}</label></div>}
                    {qtdeEngageFeature != null && qtdeEngageFeature !== '' && <div><label>Saldo empenhado: {qtdeEngageFeature}</label></div>}
                    {qtdeEngageRequest != null && qtdeEngageRequest !== '' && <div><label>Saldo empenhado na Requisição: {qtdeEngageRequest}</label></div>}

                    <div className="divGroup">
                        <div className="formDiv">
                            <label>Quantidade</label>&nbsp;<label className="required">*</label><br />
                            <input type="text" placeholder="Quantidade" value={item_form_quantidade}
                                onChange={(e) => setItemFormQuantidade(setMaskDecimal(e.target.value, 4))}
                                maxLength="30"
                                disabled={view || listMacSerieSeleted.length > 0 || (id && parseInt(localStorage.getItem("usuario")) !== solicitante && !getPermission("OPERACOES - REQUISICOES - EDITA TERCEIROS"))} />
                        </div>
                    </div>

                    <div className="divGroup">
                        <div className="formDiv">
                            <button type="button" className="buttonSubmit inputSm marginRight" onClick={addItem} disabled={view}>Confirmar</button>
                            <button type="button" className="buttonSubmit inputSm pullRight" onClick={closeModal} disabled={view}>Fechar</button>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal
                isOpen={modalFieldsOpen}
                onRequestClose={closeModal}
                style={customShortModal}
                contentLabel="Serie/MAC"
                ariaHideApp={false}
                keepMounted
            >
                <div className="body-modal">
                    <div className="formDiv">
                        <table>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>SÉRIE</th>
                                    <th>MAC</th>
                                </tr>
                            </thead>
                            <tbody>
                                {fields && fields?.length > 0 && fields.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.serie}</td>
                                            <td>{item.mac}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="formDiv">
                        <button type="button" className="buttonCancel" onClick={closeModal}>Fechar</button>
                    </div>
                </div>
            </Modal>
            <Modal
                isOpen={modalTagsReceipt}
                onRequestClose={closeModal}
                contentLabel="Etiquetas"
                style={customHalfModal}
                ariaHideApp={false}
                keepMounted
            >
                <div>
                    <h2>Etiquetas</h2>
                    <div className="formDiv">
                        <table>
                            <thead>
                                <tr>
                                    <th className="ident-th">#</th>
                                    <th>Produto</th>
                                    <th>Qtde Gerada</th>
                                    <th>Qtde Usada</th>
                                    <th>Qtde Gerar</th>
                                    {false && <th>Opções</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {listTagsReceipt.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.product}</td>
                                            <td>{item.generated}</td>
                                            <td>{item.used}</td>
                                            <td>
                                                <input type="text" placeholder="Qtde" value={item.quantity_generate} onChange={(e) => setListTags(index, e.target.value)} maxLength="30" disabled={view} />
                                            </td>
                                        </tr>
                                    )
                                })}
                                <tr>
                                    <td colSpan={4}></td>
                                    <td>
                                        {label_message_tag != '' && <div className="divCarryingSmall">
                                          <span>{label_message_tag}..</span>
                                          <FaCog icon="spinner" className="spinner" />
                                        </div>}
                                        {label_message_tag == '' && <button type="button" className="buttonSubmitModal inputSmModal inputSpread" onClick={generateTags}>Gerar</button>}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    
                    <div className="formDiv">
                        <button type="button" className="buttonCancel" onClick={closeModal} disabled={view}>Fechar</button>
                    </div>
                </div>
            </Modal>
            <ModalChoice customStyle={customShortModal} ifOnNotIsFunction={true} functionOnNot={() => {setModalConfirmPrintTags(false)}} ifOnYesIsFunction={true} functionOnYes={() => getPrintTag()} state={modalConfirmPrintTags} title={`Você deseja imprimir as ${listTagsToPrint.length} etiquetas geradas para esse recebimento?`} view={view} />
            <ModalChoice customStyle={customShortModal} ifOnNotIsFunction={true} functionOnNot={() => {setModalConfirmTags(false)}} ifOnYesIsFunction={true} functionOnYes={() => saveAndGetListTags()} state={modalConfirmTags} title={`Há alteração não salvas, para imprimir etiquetas é preciso salvar. Deseja salvar?`} view={view} />
            
            <ModalFeaturesOpen customStylesFeatures={customStylesFeatures} feature={feature} listFeatures={listFeatures} modalFeaturesOpen={modalFeaturesOpen} status={status} saveFeatures={saveFeatures} setFeature={setFeature} setModalFeaturesOpen={setModalFeaturesOpen} items={{ solicitante }} view={view} />
            <ModalLogFeaturesOpen customStylesFeatures={customStylesFeatures} listFeatures={logFeature} modalFeaturesOpen={modalLogFeaturesOpen} setModalLogFeaturesOpen={setModalLogFeaturesOpen} />
            <ModalFinalizeSeparation customStyles={customFullModal} showModalFinishSeparation={modalFinishSeparation} setShowModalFinishSeparation={setModalFinishSeparation} id={id} rows={rows} setCarrying={setCarrying} setStatus={setStatus} URL={`/api/products_requests/${id}/finalizar`} method={"put"} />
            <ModalStartSeparation customStyles={customFullModal} showModalStartSeparation={modalStartSeparation} setShowModalStartSeparation={setModalStartSeparation} setCarrying={setCarrying} setStatus={setStatus} id={id} />
            <ModalReverseSeparation customStyles={customFullModal} modalReverseSeparation={modalReverseSeparation} setModalReverseSeparation={setModalReverseSeparation} id={id} setCarrying={setCarrying} setStatus={setStatus} />
            <ModalReverseAproveSeparation customStyles={customFullModal} modalReverseAproveSeparation={modalReverseAproveSeparation} setModalReverseAproveSeparation={setModalReverseAproveSeparation} setCarrying={setCarrying} setStatus={setStatus} id={id} API={`/api/product_requests/setReverseAprovation?id=${id}`} APIMethod={'get'} APIBody={{ empresa: localStorage.empresa, usuario: localStorage.usuario, status: status, data: inputsValues.data_solicitacao, hora: hora_solicitacao, }} />
            <ModalPauseSeparation modalPauseSeparation={modalPauseSeparation} setModalPauseSeparation={setModalPauseSeparation} id={id} setCarrying={setCarrying} setStatus={setStatus} />
            <ModalMakeReturn customStyles={customFullModal} listProducts={listProducts} listReturn={listReturn} modalMakeReturn={modalMakeReturn} observation_return={observation_return} setItemReturn={setItemReturn} setModalMakeReturn={setModalMakeReturn} setObservationReturn={setObservationReturn} setCarrying={setCarrying} redirect={'/product_requests'} view={view} id={id} />
            <ModalDeliverSignature screenName={"Solicitação"} id={id} showModalDeliverSignature={showModalDeliverSignature} setShowModalDeliverSignature={setShowModalDeliverSignature} getOne={getOne} option={option} status={status} receiverID={receiverID} setReceiverID={setReceiverID} receiver={receiver} setReceiver={setReceiver} signature={signature} setSignature={setSignature} base64={infos.signature.base64} users={employees} API={`/api/products_requests/${id}/entregar`} method={"put"} />
            <ModalViewLog modalViewLog={modalViewLog} closeModal={closeModal} listProducts={listProducts} viewLogFeatures={viewLogFeatures} view_log={view_log} view={view} />
            <ModalSeparation showSeparationModal={showSeparationModal} closeModal={closeModal} view={view} separations={separations} setShowSeparationModal={setShowSeparationModal} />
            <ModalLog modalLog={modalLog} closeModal={closeModal} view={view} listLogSeparation={listLogSeparation} />
        </div>
    )
}